import React, { memo, ReactNode } from 'react'
import classNames from 'classnames'
import { makeStyles, Typography } from 'transfix-ui/core'
import { DISPLAY } from 'constants/display'

const useStackedLabelValueStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface IStackedLabelValueProps {
  label: string
  labelClassName?: string
  labelNote?: ReactNode
  value: ReactNode
  valueClassName?: string
  className?: string
}

const StackedLabelValue = memo<IStackedLabelValueProps>(
  ({ className, label, labelClassName, labelNote, value, valueClassName }) => {
    const classes = useStackedLabelValueStyles()
    const rootClasses = classNames(classes.root, className)

    return (
      <div className={rootClasses}>
        <div className={labelClassName}>
          <Typography variant='caption' color='textSecondary'>
            {label}
          </Typography>
          {labelNote}
        </div>
        {!value || typeof value === 'string' ? (
          <Typography variant='body1'>{value || DISPLAY.empty}</Typography>
        ) : (
          <div className={valueClassName}>{value}</div>
        )}
      </div>
    )
  }
)

export default StackedLabelValue
